export default __webpack_public_path__ + "static/Row 4.2_TMJC-8f6e10330d3dc7025a5c5cb8fbde9585.jpg";